// enums for permissions to use for consistency throughout the app
const permissions = {
    none: 0,
    view: 1,
    edit: 2,
    admin: 3
};

export default permissions